export const LEGACY_WRAPPER = 'legacy'

export const FIELD_NAME = {FROM: 'from', TO: 'to'}

export const LABEL_FIRST_OPTION = {
  [FIELD_NAME.FROM]: 'COMMON_FROM',
  [FIELD_NAME.TO]: 'COMMON_TO'
}

export const EMPTY_STRING = ''
